const removeProtocol = (url: string): string =>
  url ? url.split('://')[1] : 'www.domain.com.au';

export default removeProtocol;
